import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { HttpService } from '../../../services/http.service';
import { ErrorNoticeService } from '../../../services/error-notice.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit, OnDestroy {

  @Input() numErrors: number = 0;
  @Input() title: string;
  
  @Input() systemId: string;
  @Input() subSystemId: string = null;
  @Input() max: number = 10;
  @Input() min: number = 0;
  errorObjs: any[];
  previousNumErrors;

  subscription: ISubscription;

  constructor(private http: HttpService, private cdref: ChangeDetectorRef, private errorNotice: ErrorNoticeService) {
  }

  ngOnInit() {

    // setInterval(() => {
    //   this.errorNotice.PlayError();
    // }, 5000);

    this.makeErrorObjArray(0);

    this.previousNumErrors = this.numErrors;
    this.http.dashboardData().subscribe(data => {
      let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
      if (filtered.length > 0){
        this.numErrors = this.clip(filtered[0].value, this.min, this.max);
        if (this.numErrors != this.previousNumErrors){
          this.makeErrorObjArray(this.numErrors);
          this.cdref.detectChanges();

          if(this.previousNumErrors < this.numErrors){
            this.errorNotice.PlayError();
          }
          this.previousNumErrors = this.numErrors;
        }
      }
    });
  }

  clip(value, min, max){
    let res = value;
    if (value < min) res = min;
    if (value > max) res = max;
    return res;
  }

  makeErrorObjArray(num){
    // error markers display
    this.errorObjs = [];
    for (let i = 0; i < 10; i++){
      if (i < num){
        this.errorObjs.push({
          error:true
        });
      }
      else {
        this.errorObjs.push({
          error:false
        })
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stats/errors/errors.component.ts